/* Seerat PDP v2 — variant picking, add to cart, GoKwik buy now, delivery estimate by pincode zone,
   sticky add-to-cart, size guide, photo zoom, colour swatches, prepaid price, low stock, notify me,
   wishlist, share, customer photos + fit summary from reviews, and event tracking. */
(function () {
  if (window.customElements.get('seerat-pdp')) return;

  var SIZE_ALIASES = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL' };
  var WISHLIST_KEY = 'seeratWishlist';

  function money(cents) {
    var amount = (Number(cents) || 0) / 100;
    var hasPaise = Math.round(amount * 100) % 100 !== 0;
    return '₹' + amount.toLocaleString('en-IN', { minimumFractionDigits: hasPaise ? 2 : 0, maximumFractionDigits: 2 });
  }

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // skip Sundays
    }
    return d;
  }

  function fmtDate(d) {
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function storageGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function storageSet(key, val) { try { window.localStorage.setItem(key, val); } catch (e) { /* ignore */ } }

  function readJson(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  /* One call fans out to every analytics tool on the store that is present:
     Microsoft Clarity, Shopify customer events, GA4 (gtag / dataLayer) and Meta pixel. */
  function track(name, props) {
    props = props || {};
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) { /* ignore */ }
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, props); } catch (e) { /* ignore */ }
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) { /* ignore */ }
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, props)); } catch (e) { /* ignore */ }
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, props); } catch (e) { /* ignore */ }
  }

  class SeeratPdp extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-product-json]');
      if (!json) return;
      try { this.product = JSON.parse(json.textContent); } catch (e) { return; }

      this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-option-group]'));
      this.sizeGroup = this.querySelector('[data-size-group]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.form = this.querySelector('[data-product-form]');
      this.atc = this.querySelector('[data-add-to-cart]');
      this.atcLabel = this.querySelector('[data-atc-label]');
      this.buyNow = this.querySelector('[data-buy-now]');
      this.sizeError = this.querySelector('[data-size-error]');
      this.showSave = this.dataset.showSave === 'true';
      this.showMrp = this.dataset.showMrp === 'true';
      this.sizeChosen = this.dataset.sizeRequired !== 'true';
      this.prepaidPct = parseFloat(this.dataset.prepaidPct) || 0;
      this.lowStock = parseInt(this.dataset.lowStock, 10) || 0;
      this.stock = readJson(this.querySelector('[data-stock]'), {});
      this.handle = this.dataset.handle || this.product.handle;
      this.base = { product_id: String(this.product.id), handle: this.handle, pdp_version: 'v2' };

      this.bindOptions();
      this.bindForm();
      this.bindBuyNow();
      this.bindGallery();
      this.bindZoom();
      this.bindSticky();
      this.bindDelivery();
      this.bindSizeGuide();
      this.bindWishlist();
      this.bindShare();
      this.bindNotify();
      this.bindLinks();
      this.bindReviewProof();
      this.update(false);

      try { if (typeof window.clarity === 'function') window.clarity('set', 'pdp_version', 'v2'); } catch (e) { /* ignore */ }
      this.track('pdp_view', {});
    }

    track(name, props) {
      track(name, Object.assign({}, this.base, props || {}));
    }

    /* ───── Variants ───── */
    selectedOptions() {
      return this.groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    findVariant(opts) {
      return this.product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === undefined ? false : o === opts[i]; });
      }) || null;
    }

    sizeValue() {
      if (!this.sizeGroup) return null;
      var c = this.sizeGroup.querySelector('input:checked');
      return c ? c.value : null;
    }

    bindOptions() {
      var self = this;
      this.groups.forEach(function (g) {
        g.addEventListener('change', function () {
          if (g === self.sizeGroup) {
            self.sizeChosen = true;
            g.classList.remove('is-attention');
            if (self.sizeError) self.sizeError.hidden = true;
            self.track('pdp_size_select', { size: self.sizeValue() });
          }
          self.update(true);
        });
      });
    }

    update(pushUrl) {
      var opts = this.selectedOptions();
      var variant = this.product.variants.length === 1 ? this.product.variants[0] : this.findVariant(opts);
      this.variant = variant;

      this.groups.forEach(function (g, i) {
        var label = g.querySelector('[data-option-value]');
        if (label && opts[i]) label.textContent = opts[i];
      });

      var self = this;
      this.groups.forEach(function (g, gi) {
        g.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var avail = self.product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] === null ? true : o === test[i]; });
          });
          var pill = input.nextElementSibling;
          if (pill) pill.classList.toggle('is-unavailable', !avail);
        });
      });

      var priceVariant = variant || this.product.variants.find(function (v) { return v.available; }) || this.product.variants[0];
      if (priceVariant) this.renderPrice(priceVariant);
      this.renderStickySize();

      if (!variant) {
        if (this.sizeChosen) { this.setAtc(false, 'Unavailable', false); } else { this.setAtc(true, 'Add to cart', true); }
        this.renderLowStock(null);
        this.renderNotify(null);
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      this.renderPrice(variant);
      this.renderFit(opts);
      this.renderLowStock(variant);
      this.renderNotify(variant);

      if (!this.sizeChosen) {
        this.setAtc(true, 'Add to cart', true);
      } else if (variant.available) {
        this.setAtc(true, 'Add to cart', false);
      } else {
        this.setAtc(false, 'Sold out', false);
      }

      if (pushUrl && this.sizeChosen && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      if (pushUrl && variant.featured_media) this.scrollToMedia(variant.featured_media.id);
    }

    setAtc(enabled, label, soft) {
      if (this.atc) {
        this.atc.disabled = !enabled;
        this.atc.classList.toggle('is-soft', !!soft);
      }
      if (this.atcLabel) this.atcLabel.textContent = label;
      if (this.buyNow) {
        this.buyNow.disabled = !enabled;
        this.buyNow.classList.toggle('is-soft', !!soft);
      }
      var stickyBtn = this.querySelector('[data-sticky-atc]');
      if (stickyBtn) {
        var soldOut = !enabled && label === 'Sold out';
        stickyBtn.textContent = soldOut ? 'Notify me' : (enabled ? (soft ? 'Select size' : 'Add to cart') : label);
        stickyBtn.disabled = !enabled && !soldOut;
      }
    }

    renderPrice(v) {
      var priceEl = this.querySelector('[data-price]');
      var stickyPrice = this.querySelector('[data-sticky-price]');
      var mrpWrap = this.querySelector('[data-mrp]');
      var compareEl = this.querySelector('[data-compare]');
      var saveWrap = this.querySelector('[data-save]');
      var savePct = this.querySelector('[data-save-pct]');
      var prepaid = this.querySelector('[data-prepaid-price]');
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (mrpWrap) mrpWrap.hidden = !(onSale && this.showMrp);
      if (compareEl && onSale) compareEl.textContent = money(v.compare_at_price);
      if (saveWrap) saveWrap.hidden = !(onSale && this.showSave);
      if (savePct && onSale) savePct.textContent = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
      if (prepaid && this.prepaidPct > 0) {
        var rupees = Math.floor((v.price * (100 - this.prepaidPct)) / 10000);
        prepaid.textContent = money(rupees * 100);
      }
    }

    renderStickySize() {
      var el = this.querySelector('[data-sticky-size]');
      if (!el) return;
      var size = this.sizeValue();
      el.textContent = this.sizeGroup ? (this.sizeChosen && size ? 'Size ' + size : 'Select a size') : '';
    }

    renderFit(opts) {
      if (!this.sizeGroup) return;
      var idx = parseInt(this.sizeGroup.dataset.optionIndex, 10);
      var size = opts[idx];
      var title = this.querySelector('[data-fit-title]');
      var tiles = this.querySelector('[data-fit-tiles]');
      var rows = this.querySelectorAll('[data-size-chart] tbody tr');
      rows.forEach(function (r) { r.classList.remove('is-current'); });
      if (!size || !this.sizeChosen) return;
      var key = String(size).toUpperCase();
      key = SIZE_ALIASES[key] || key;
      var row = this.querySelector('[data-size-chart] tr[data-size="' + key + '"]');
      if (!row || !tiles) return;
      row.classList.add('is-current');
      var cells = row.querySelectorAll('td');
      tiles.querySelectorAll('[data-fit]').forEach(function (el) {
        var c = cells[parseInt(el.dataset.fit, 10) - 1];
        el.textContent = c ? c.dataset.in + '″' : '—';
      });
      tiles.hidden = false;
      if (title) title.textContent = 'Size ' + size + ' · from our size chart (inches)';
    }

    /* Real inventory only; the page source carries counts at or below the threshold, nothing larger. */
    renderLowStock(variant) {
      var el = this.querySelector('[data-low-stock-msg]');
      if (!el) return;
      var qty = variant ? this.stock[String(variant.id)] : null;
      if (this.lowStock > 0 && this.sizeChosen && variant && variant.available && typeof qty === 'number' && qty > 0 && qty <= this.lowStock) {
        var size = this.sizeValue();
        el.textContent = 'Only ' + qty + ' left' + (size ? ' in ' + size : '') + '.';
        el.hidden = false;
        this.track('pdp_low_stock_shown', { size: size, qty: qty });
      } else {
        el.hidden = true;
      }
    }

    renderNotify(variant) {
      var box = this.querySelector('[data-notify]');
      if (!box) return;
      var posted = /customer_posted=true/.test(window.location.search) && !!box.querySelector('[data-notify-done]');
      var soldOut = this.sizeChosen && variant && !variant.available;
      box.hidden = !(soldOut || posted);
      if (!soldOut) return;
      var size = this.sizeValue();
      var title = box.querySelector('[data-notify-title]');
      if (title) title.textContent = (size ? 'Size ' + size : 'This option') + ' is sold out.';
      var wa = box.querySelector('[data-notify-wa]');
      if (wa) {
        var text = 'Hi, please let me know when ' + (this.dataset.productTitle || '') + (size ? ' in size ' + size : '') + ' is back in stock. ' + (this.dataset.productUrl || window.location.href);
        wa.href = 'https://wa.me/' + (this.dataset.waNumber || '') + '?text=' + encodeURIComponent(text);
      }
      var tags = box.querySelector('[data-notify-tags]');
      if (tags) tags.value = 'back-in-stock,bis:' + this.handle.slice(0, 180) + (size ? ':' + size : '');
    }

    requireSize() {
      if (this.sizeChosen || !this.sizeGroup) return true;
      this.sizeGroup.classList.remove('is-attention');
      void this.sizeGroup.offsetWidth;
      this.sizeGroup.classList.add('is-attention');
      if (this.sizeError) this.sizeError.hidden = false;
      this.sizeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = this.sizeGroup.querySelector('input');
      if (first) first.focus({ preventScroll: true });
      this.track('pdp_size_required', {});
      return false;
    }

    /* ───── Add to cart (same flow as the previous block, so the cart drawer reacts) ───── */
    bindForm() {
      var self = this;
      if (!this.form || !this.atc) return;
      this.form.addEventListener('submit', async function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.track('pdp_add_to_cart_click', { size: self.sizeValue(), size_chosen: self.sizeChosen });
        if (!self.requireSize()) return;
        if (self.atc.disabled || !self.variant || !self.variant.available) return;

        var original = self.atcLabel ? self.atcLabel.textContent : '';
        self.atc.disabled = true;
        self.atc.classList.add('is-pending');
        if (self.atcLabel) self.atcLabel.textContent = 'Adding…';
        try {
          var response = await fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(self.form)
          });
          if (!response.ok) {
            var err = await response.json().catch(function () { return {}; });
            throw new Error(err.description || 'Unable to add this to your cart');
          }
          var item = await response.json();
          if (self.atcLabel) self.atcLabel.textContent = 'Added';
          self.track('pdp_add_to_cart', { variant_id: String(self.variant.id), size: self.sizeValue(), value: self.variant.price / 100, currency: 'INR' });
          ['cart:updated', 'seerat:cart-updated'].forEach(function (name) {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { item: item } }));
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          // Impulse's own cart drawer (with the GoKwik checkout button) opens on this event
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item, addToCartBtn: self.atc } }));
          setTimeout(function () { if (self.atcLabel) self.atcLabel.textContent = original || 'Add to cart'; }, 1500);
        } catch (error) {
          if (self.sizeError) {
            self.sizeError.textContent = error.message || 'Something went wrong. Please try again.';
            self.sizeError.hidden = false;
          }
          if (self.atcLabel) self.atcLabel.textContent = original || 'Add to cart';
          self.track('pdp_add_to_cart_error', { message: String(error && error.message || '') });
        } finally {
          self.atc.disabled = false;
          self.atc.classList.remove('is-pending');
        }
      });
    }

    /* ───── Buy now → GoKwik (identical to the previous block) ───── */
    bindBuyNow() {
      var self = this;
      if (!this.buyNow) return;
      this.buyNow.addEventListener('click', async function (event) {
        event.preventDefault();
        self.track('pdp_buy_now_click', { size: self.sizeValue(), size_chosen: self.sizeChosen });
        if (!self.requireSize()) return;
        if (!self.variant || !self.variant.available) return;
        self.buyNow.disabled = true;
        var original = self.buyNow.textContent;
        self.buyNow.textContent = 'Processing…';
        try {
          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: self.variant.id, quantity: 1 })
          });
          if (!response.ok) throw new Error('Unable to add this to your cart');
          await response.json();
          await new Promise(function (resolve) { setTimeout(resolve, 800); });
          var gk = document.getElementById('gokwik-buy-now');
          if (!gk) {
            window.location.href = '/checkout';
            return;
          }
          gk.disabled = false;
          gk.classList.remove('disabled');
          if (typeof window.onBuyNowClick === 'function') { window.onBuyNowClick(gk); } else { gk.click(); }
        } catch (error) {
          if (self.sizeError) {
            self.sizeError.textContent = 'Something went wrong. Please try again.';
            self.sizeError.hidden = false;
          }
        } finally {
          self.buyNow.disabled = false;
          self.buyNow.textContent = original;
        }
      });
    }

    /* ───── Gallery dots ───── */
    bindGallery() {
      var gallery = this.querySelector('[data-gallery]');
      var dots = this.querySelectorAll('[data-dot]');
      if (!gallery || !dots.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var i = e.target.dataset.index;
            dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.dot === i); });
          }
        });
      }, { root: gallery, threshold: [0.6] });
      gallery.querySelectorAll('.spdp__slide').forEach(function (s) { io.observe(s); });
    }

    scrollToMedia(mediaId) {
      var gallery = this.querySelector('[data-gallery]');
      var slide = this.querySelector('.spdp__slide[data-media-id="' + mediaId + '"]');
      if (!gallery || !slide || window.matchMedia('(min-width: 990px)').matches) return;
      gallery.scrollTo({ left: slide.offsetLeft - 16, behavior: 'smooth' });
    }

    /* ───── Zoom viewer: tap a photo to open, tap again to zoom, drag to pan, swipe for the next ───── */
    bindZoom() {
      var dialog = this.querySelector('[data-zoom]');
      if (!dialog) return;
      var self = this;
      var trackEl = dialog.querySelector('[data-zoom-track]');
      var slides = Array.prototype.slice.call(dialog.querySelectorAll('[data-zoom-slide]'));
      var counter = dialog.querySelector('[data-zoom-count]');
      if (!trackEl || !slides.length) return;

      function load(i) {
        var s = slides[i];
        if (!s) return;
        var img = s.querySelector('img[data-src]');
        if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      }
      function current() { return Math.max(0, Math.min(slides.length - 1, Math.round(trackEl.scrollLeft / Math.max(1, trackEl.clientWidth)))); }
      function setCount(i) { if (counter) counter.textContent = (i + 1) + ' / ' + slides.length; }
      function unzoom() {
        slides.forEach(function (s) { s.classList.remove('is-zoomed'); s.scrollLeft = 0; s.scrollTop = 0; });
        dialog.classList.remove('is-zoomed');
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        unzoom();
        load(i); load(i + 1); load(i - 1);
        trackEl.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setCount(i);
      }
      function open(i) {
        unzoom();
        if (typeof dialog.showModal === 'function') { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
        document.documentElement.classList.add('spdp-noscroll');
        load(i); load(i + 1); load(i - 1);
        requestAnimationFrame(function () { trackEl.scrollLeft = slides[i] ? slides[i].offsetLeft : 0; });
        setCount(i);
        self.track('pdp_zoom_open', { index: i });
      }
      function close() { unzoom(); if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); } }

      // Open from the gallery, but not at the end of a swipe
      var downX = 0, downY = 0;
      this.querySelectorAll('[data-zoom-open]').forEach(function (el) {
        el.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; });
        el.addEventListener('click', function (e) {
          if (Math.abs(e.clientX - downX) > 10 || Math.abs(e.clientY - downY) > 10) return;
          open(parseInt(el.dataset.zoomOpen, 10) || 0);
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(parseInt(el.dataset.zoomOpen, 10) || 0); }
        });
      });

      var scrollTimer;
      trackEl.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { var i = current(); setCount(i); load(i); load(i + 1); load(i - 1); }, 80);
      }, { passive: true });

      // Tap to zoom in at the tapped point; drag (native scroll) to pan; tap again to zoom out
      slides.forEach(function (slide) {
        var sx = 0, sy = 0;
        slide.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
        slide.addEventListener('click', function (e) {
          if (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) return;
          var zoomIn = !slide.classList.contains('is-zoomed');
          var rect = slide.getBoundingClientRect();
          var img = slide.querySelector('img');
          var ir = img ? img.getBoundingClientRect() : rect;
          var rx = Math.max(0, Math.min(1, (e.clientX - ir.left) / Math.max(1, ir.width)));
          var ry = Math.max(0, Math.min(1, (e.clientY - ir.top) / Math.max(1, ir.height)));
          slide.classList.toggle('is-zoomed', zoomIn);
          dialog.classList.toggle('is-zoomed', zoomIn);
          if (zoomIn) {
            requestAnimationFrame(function () {
              slide.scrollLeft = rx * slide.scrollWidth - rect.width / 2;
              slide.scrollTop = ry * slide.scrollHeight - rect.height / 2;
            });
            self.track('pdp_zoom_in', {});
          } else {
            slide.scrollLeft = 0; slide.scrollTop = 0;
          }
        });
      });

      var prev = dialog.querySelector('[data-zoom-prev]');
      var next = dialog.querySelector('[data-zoom-next]');
      var closeBtn = dialog.querySelector('[data-zoom-close]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      if (closeBtn) closeBtn.addEventListener('click', close);
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      });
      dialog.addEventListener('close', function () { document.documentElement.classList.remove('spdp-noscroll'); unzoom(); });
    }

    /* ───── Sticky add to cart: needs a size, sits above the mobile bottom nav ───── */
    bindSticky() {
      var bar = this.querySelector('[data-sticky]');
      var row = this.querySelector('[data-cta-row]');
      var btn = this.querySelector('[data-sticky-atc]');
      var self = this;
      if (!bar || !row || !('IntersectionObserver' in window)) return;

      if (this.dataset.hideAppSticky === 'true') document.body.classList.add('spdp-hide-app-sticky');

      function navOffset() {
        var nav = document.querySelector('.seerat-mobile-nav');
        if (!nav) return 0;
        var cs = window.getComputedStyle(nav);
        if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
        var r = nav.getBoundingClientRect();
        return r.height > 0 && r.bottom >= window.innerHeight - 4 ? Math.round(r.height) : 0;
      }
      function place() {
        var off = navOffset();
        bar.style.bottom = off + 'px';
        document.body.style.setProperty('--spdp-sticky-space', (off + bar.offsetHeight + 12) + 'px');
      }
      place();
      window.addEventListener('resize', place, { passive: true });

      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        document.body.classList.toggle('spdp-sticky-on', past);
        if (btn) btn.tabIndex = past ? 0 : -1;
        if (past) place();
      });
      io.observe(row);

      if (btn) {
        btn.addEventListener('click', function () {
          self.track('pdp_sticky_atc_click', { size_chosen: self.sizeChosen });
          if (!self.requireSize()) return;
          if (self.variant && !self.variant.available) {
            var box = self.querySelector('[data-notify]');
            if (box) { box.hidden = false; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
            return;
          }
          if (self.form.requestSubmit) { self.form.requestSubmit(); } else { self.atc.click(); }
        });
      }
    }

    /* ───── Delivery estimate by pincode zone ───── */
    bindDelivery() {
      var wrap = this.querySelector('[data-delivery]');
      if (!wrap) return;
      var self = this;
      var input = wrap.querySelector('[data-pin]');
      var check = wrap.querySelector('[data-pin-check]');
      var result = wrap.querySelector('[data-pin-result]');
      var dateEl = wrap.querySelector('[data-pin-date]');
      var err = wrap.querySelector('[data-pin-error]');
      var dMin = parseInt(this.dataset.deliveryMin, 10) || 5;
      var dMax = Math.max(dMin, parseInt(this.dataset.deliveryMax, 10) || 7);
      var zones = readJson(this.querySelector('[data-zones]'), []).map(function (z) {
        var m = String(z.days || '').match(/(\d+)\s*[-–]\s*(\d+)/) || String(z.days || '').match(/(\d+)/);
        var a = m ? parseInt(m[1], 10) : null;
        var b = m && m[2] ? parseInt(m[2], 10) : a;
        return {
          label: z.label,
          prefixes: (z.prefixes || []).map(function (p) { return String(p).replace(/\D/g, ''); }).filter(Boolean),
          min: a, max: b
        };
      }).filter(function (z) { return z.min && z.prefixes.length; });

      function zoneFor(pin) {
        var best = null, bestLen = 0;
        zones.forEach(function (z) {
          z.prefixes.forEach(function (p) {
            if (pin.indexOf(p) === 0 && p.length > bestLen) { best = z; bestLen = p.length; }
          });
        });
        return best;
      }

      function run(fromUser) {
        var pin = (input.value || '').replace(/\D/g, '').slice(0, 6);
        input.value = pin;
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          result.hidden = true;
          err.hidden = false;
          return;
        }
        err.hidden = true;
        var z = zoneFor(pin);
        var min = z ? z.min : dMin;
        var max = z ? Math.max(z.min, z.max) : dMax;
        var now = new Date();
        var a = addBusinessDays(now, min);
        var b = addBusinessDays(now, max);
        dateEl.textContent = 'Estimated delivery ' + fmtDate(a) + (max > min ? ' – ' + fmtDate(b) : '');
        result.hidden = false;
        storageSet('seerat_pin', pin);
        if (fromUser) self.track('pdp_pincode_check', { zone: z ? z.label : 'default', pin_prefix: pin.slice(0, 3) });
      }

      check.addEventListener('click', function () { run(true); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(true); } });
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        if (input.value.length === 6) run(true);
      });
      var saved = storageGet('seerat_pin');
      if (saved) { input.value = saved; run(false); }
    }

    /* ───── Size guide ───── */
    bindSizeGuide() {
      var dialog = this.querySelector('[data-size-dialog]');
      if (!dialog) return;
      var self = this;
      this.querySelectorAll('[data-size-guide-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (typeof dialog.showModal === 'function') { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
          self.track('pdp_size_guide_open', {});
        });
      });
      var close = dialog.querySelector('[data-size-guide-close]');
      if (close) close.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog && dialog.close) dialog.close(); });
      var units = dialog.querySelectorAll('[data-unit]');
      units.forEach(function (u) {
        u.addEventListener('click', function () {
          var cm = u.dataset.unit === 'cm';
          units.forEach(function (x) {
            var on = x === u;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          dialog.querySelectorAll('td[data-in]').forEach(function (td) {
            var inch = parseFloat(td.dataset.in);
            td.textContent = cm ? (Math.round(inch * 2.54 * 10) / 10).toFixed(1) : String(inch);
          });
        });
      });
    }

    /* ───── Wishlist: the store's own list (header heart + /pages/wishlist) ───── */
    bindWishlist() {
      var btn = this.querySelector('[data-wishlist]');
      if (!btn) return;
      var self = this;
      function list() {
        try { var l = JSON.parse(storageGet(WISHLIST_KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
      }
      function paint() {
        var on = list().indexOf(self.handle) !== -1;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
        btn.title = on ? 'Saved to wishlist' : 'Save to wishlist';
      }
      btn.addEventListener('click', function () {
        var l = list();
        var i = l.indexOf(self.handle);
        if (i === -1) { l.push(self.handle); } else { l.splice(i, 1); }
        storageSet(WISHLIST_KEY, JSON.stringify(l));
        document.dispatchEvent(new CustomEvent('seerat:wishlist:updated', { detail: { handle: self.handle } }));
        paint();
        self.track(i === -1 ? 'pdp_wishlist_add' : 'pdp_wishlist_remove', {});
      });
      window.addEventListener('storage', paint);
      paint();
    }

    /* ───── Share: native share sheet on phones, WhatsApp elsewhere ───── */
    bindShare() {
      var btn = this.querySelector('[data-share]');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', async function () {
        var url = self.dataset.productUrl || window.location.href;
        var title = self.querySelector('.spdp__title') ? self.querySelector('.spdp__title').textContent.trim() : document.title;
        if (navigator.share) {
          try {
            await navigator.share({ title: title, text: title + ' — Seerat', url: url });
            self.track('pdp_share', { method: 'native' });
            return;
          } catch (e) {
            if (e && e.name === 'AbortError') return;
          }
        }
        window.open('https://wa.me/?text=' + encodeURIComponent(title + ' — ' + url), '_blank', 'noopener');
        self.track('pdp_share', { method: 'whatsapp' });
      });
    }

    /* ───── Notify me ───── */
    bindNotify() {
      var box = this.querySelector('[data-notify]');
      if (!box) return;
      var self = this;
      var wa = box.querySelector('[data-notify-wa]');
      if (wa) wa.addEventListener('click', function () { self.track('pdp_notify_whatsapp', { size: self.sizeValue() }); });
      var form = box.querySelector('form');
      if (form) form.addEventListener('submit', function () { self.track('pdp_notify_email', { size: self.sizeValue() }); });
      if (/customer_posted=true/.test(window.location.search) && box.querySelector('[data-notify-done]')) {
        box.hidden = false;
        setTimeout(function () { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
      }
    }

    /* ───── Link tracking: WhatsApp help and colour swatches ───── */
    bindLinks() {
      var self = this;
      this.querySelectorAll('[data-wa-source]').forEach(function (a) {
        a.addEventListener('click', function () { self.track('pdp_whatsapp_click', { source: a.dataset.waSource }); });
      });
      this.querySelectorAll('[data-swatch]').forEach(function (a) {
        a.addEventListener('click', function () { self.track('pdp_colour_swatch', { to: a.getAttribute('aria-label') || '' }); });
      });
    }

    /* ───── Customer photos + fit summary, read from the Judge.me reviews on this page ───── */
    bindReviewProof() {
      var box = this.querySelector('[data-review-proof]');
      var widget = this.querySelector('#judgeme_product_reviews') || document.getElementById('judgeme_product_reviews');
      if (!box || !widget) return;
      var self = this;
      var tries = 0;

      function build() {
        var reviews = widget.querySelectorAll('.jdgm-rev');
        if (!reviews.length) return false;

        // Photos
        var seen = {}, photos = [];
        widget.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic-img, .jdgm-rev__pics [data-src]').forEach(function (img) {
          var src = img.getAttribute('data-src') || img.currentSrc || img.getAttribute('src') || '';
          if (!src || /^data:/.test(src) || seen[src]) return;
          seen[src] = true;
          photos.push(src);
        });
        var photoWrap = box.querySelector('[data-review-photos]');
        var strip = box.querySelector('[data-review-photo-strip]');
        if (photos.length && strip && photoWrap) {
          strip.textContent = '';
          photos.slice(0, 6).forEach(function (src, i) {
            var a = document.createElement('button');
            a.type = 'button';
            a.className = 'spdp__proof-photo';
            a.setAttribute('aria-label', 'See customer photo ' + (i + 1) + ' in reviews');
            var img = document.createElement('img');
            img.src = src; img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64;
            a.appendChild(img);
            a.addEventListener('click', function () {
              var target = self.querySelector('.spdp__reviews') || widget;
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              self.track('pdp_review_photo_click', { index: i });
            });
            strip.appendChild(a);
          });
          photoWrap.hidden = false;
        }

        // Fit: answers to a Judge.me custom question whose title mentions fit or size
        var counts = {}, total = 0;
        widget.querySelectorAll('[class*="cf-ans"], [class*="custom-form"] [class*="answer"]').forEach(function (el) {
          var t = el.querySelector('[class*="title"], [class*="question"], b, strong');
          var title = t ? t.textContent : '';
          if (!/fit|size/i.test(title)) return;
          var v = el.querySelector('[class*="value"], [class*="answer"]');
          var value = (v ? v.textContent : el.textContent.replace(title, '')).replace(/^[\s:]+/, '').trim();
          if (!value || value.length > 40) return;
          counts[value] = (counts[value] || 0) + 1;
          total++;
        });
        var fitEl = box.querySelector('[data-fit-summary]');
        if (fitEl && total >= 3) {
          var top = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
          var pct = Math.round((counts[top] * 100) / total);
          fitEl.textContent = 'Fit: ' + pct + '% of reviewers say “' + top + '”';
          fitEl.hidden = false;
        }

        box.hidden = !(photos.length || (fitEl && !fitEl.hidden));
        return true;
      }

      (function poll() {
        if (build() || ++tries > 20) return;
        setTimeout(poll, 500);
      })();
    }
  }

  window.customElements.define('seerat-pdp', SeeratPdp);
})();
